import React from "react";
import "./contactuspage.css";
import contactImg from "../../assets/contactCall.svg";
import contactImg1 from "../../assets/contactMail.svg";
import contactImg2 from "../../assets/contactmap.svg";

export default function GetInTouch() {
  let getInTouchData = [
    {
      titleInput: "Email Address",
      subTitle: "Info@leducchimneysweep.com",
      imgIcon: contactImg1,
    },
    { imgIcon: contactImg, titleInput: "Call Us", subTitle: "780-986-1181" },
    {
      imgIcon: contactImg2,
      titleInput: "Address",
      subTitle: "#4 5907-45 Street Leduc, AB",
    },
  ];
  return (
    <div className="blk_yellow_container">
      <div className="yellow_outside_container">
        <div className="yellow_container">
          <h6>
            Lets Get in <br />
            <span>Touch</span>
          </h6>

          <div className="three_contact_container">
            {getInTouchData?.map((item, index) => {
              return (
                <div key={index} className="email_contact_container">
                  <div className="contact_img_container">
                    <img src={item?.imgIcon} alt="imgContact" loading="lazy" />
                  </div>
                  <div className="content_container">
                    <p>{item?.titleInput}</p>
                    <a>{item?.subTitle}</a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="black_container">
        <form className="all_inputs_container">
          <input type="text" placeholder="First name" /> <br />
          <input type="text" placeholder="Last Name" /> <br />
          <input type="number" placeholder="Cell No" /> <br />
          <input type="email" placeholder="Email" /> <br />
          <input type="city" placeholder="City" /> <br />
          <input type="text" placeholder="Address" /> <br />
          <input type="text" placeholder="Subject" /> <br />
          <input type="number" placeholder="Postal Code" /> <br />
          <textarea type="text" placeholder="Message"></textarea>
          <br />
          <button>Submit</button>
        </form>
      </div>
    </div>
  );
}
